/* import React, { Component } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

class LatexText extends Component {
  render() {
    const { text } = this.props;
    const html = katex.renderToString(text, { throwOnError: false });
    console.debug("html>>??", html)
    return <span dangerouslySetInnerHTML={{ __html: html }} />;
  }
}

export default LatexText;
 */

import React, { Component } from 'react'
import { Stage, Image, Layer, Arrow, Line, Text, Circle, Arc, Label, Tag, RegularPolygon, Group } from 'react-konva'
import Victor from "victor";
import katex from "katex";
import 'katex/dist/katex.min.css';


class LatexText extends Component {

    constructor(props) {
        super(props)
        this.state = { image: null, textRendered: null, bgColorRendered: null, borderColorRendered: null };
    }

    componentDidMount() {
        this.renderLatex();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.text !== this.props.text || prevProps.bgColor !== this.props.bgColor || prevProps.borderColor !== this.props.borderColor) {
            this.renderLatex();
        }
    }

    renderLatex() {
        let { text } = this.props;
        const bgColor = this.props.bgColor ?? "#f3f383";
        const borderColor = this.props.borderColor ?? "#e4e4e4";
        const textColor = this.props.textColor ?? "black";
        if (this.state.textRendered === text && this.state.bgColorRendered === bgColor && this.state.borderColorRendered === borderColor) return; // already rendered
        // text = text.replace("\\vec{", "\\vec{\\mathrm{")
        // text += "}";
        // text = text.replace("\\vec", "\\overrightarrow")

        // text = text.replace("\\vec", "\\overset{\\longrightarrow}")
        // text = text.replace("\\vec", "\\overset{\\rightarrow}")
        text = text.replaceAll("\\vec{", "\\overrightarrow{\\mathstrut ");


        // console.debug("text>>??", text)
        
        let html = katex.renderToString(text, { throwOnError: false, output:'mathml' });
        
        // console.debug("html>>??", html);

        const temp = document.createElement("div");
        temp.style.visibility = "hidden";
        temp.style.position = "absolute";
        temp.innerHTML = html;
        document.body.appendChild(temp);
        const width = temp.offsetWidth + 4;  // small padding
        const height = temp.offsetHeight + 4;
        document.body.removeChild(temp);

        const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="100">
            <foreignObject x="0" y="0" width="${width}" height="100">
                <div xmlns="http://www.w3.org/1999/xhtml" style="font-size:16px; padding:1px; background:${bgColor}; font-style: normal;
                color: ${textColor}; 
                border-radius:6px; display:inline-block; border: 1px solid ${borderColor};">
                    ${html}
                </div>
            </foreignObject>
        </svg>
    `;

        const blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(blob);

        const img = new window.Image();
        img.src = url;
        img.onload = () => {
            this.setState({ image: img, textRendered: text, bgColorRendered: bgColor, borderColorRendered: borderColor });
            if (this.props.onSizeChange) {
                this.props.onSizeChange({ width: width, height });
            }
            URL.revokeObjectURL(url);
        };
    }


    render() {
        return (
            <Group>
                {this.state.image ? <Image image={this.state.image} /> : null}
            </Group>
        );
    }
}

export default LatexText;